import {connect} from '../../app/connect';
import TemplatesFilterPanel from './TemplatesFilterPanel';
import {isTemplatesFilterChanged} from '../../app/selectors';

const mapStateToProps = state => ({
  isFiltered: isTemplatesFilterChanged(state)
});

export default connect(mapStateToProps)(TemplatesFilterPanel);
